<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 34 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.77775 36.6667C2.01386 36.6667 1.35993 36.3923 0.815958 35.8435C0.271986 35.2947 0 34.6349 0 33.8643C0 33.0937 0.274722 32.4375 0.824167 31.8958C1.37356 31.3542 2.03401 31.0833 2.80554 31.0833H30.5556C31.3195 31.0833 31.9734 31.3558 32.5174 31.9007C33.0614 32.4457 33.3333 33.1008 33.3333 33.866C33.3333 34.6313 33.0586 35.2894 32.5092 35.8403C31.9598 36.3912 31.2993 36.6667 30.5278 36.6667H2.77775ZM6.11108 23.8611H8.11108L23.3056 8.6805L21.2917 6.66663L6.11108 21.8611V23.8611ZM3.33333 25.2483V21.3198C3.33333 21.1344 3.36574 20.9561 3.43054 20.7848C3.49538 20.6135 3.60186 20.4538 3.75 20.3056L23.2778 0.791667C23.5463 0.523139 23.8496 0.324069 24.1875 0.194458C24.5255 0.0648191 24.8704 0 25.2223 0C25.5741 0 25.926 0.0648191 26.2778 0.194458C26.6297 0.324069 26.9352 0.527764 27.1945 0.805542L29.1805 2.80554C29.4583 3.05554 29.6644 3.35647 29.7986 3.70833C29.9329 4.06017 30 4.41529 30 4.77371C30 5.10974 29.9347 5.44639 29.804 5.78367C29.6734 6.12094 29.4656 6.42915 29.1805 6.70829L9.66663 26.2222C9.51849 26.3704 9.36139 26.4769 9.19533 26.5417C9.02925 26.6065 8.85765 26.6389 8.68054 26.6389H4.73129C4.33521 26.6389 4.00319 26.5056 3.73525 26.2391C3.46731 25.9726 3.33333 25.6423 3.33333 25.2483Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#3E3B39",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
